import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Watchlist.css";
import deleteicon from "../../assets/deleteicon.svg";
import {
  fetchWatchlist,
  deleteWatchlistItem,
} from "../../redux/slice/watchlistSlice";
import { useNavigate } from "react-router-dom";
import { fetchStockDetails } from "../../redux/slice/tickerSlice";
import { FaSort } from "react-icons/fa";

function Watchlist() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const watchlist = useSelector((state) => state?.watchlist?.stocks);

  const [alerts, setAlerts] = useState([]);
  const [showAlerts, setShowAlerts] = useState(false);
  const unreadCount = alerts.filter((a) => !a.is_read).length;

  // 🔹 Sorting state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  useEffect(() => {
    dispatch(fetchWatchlist());

    fetch("/api/watchlist/alerts/", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((r) => r.json())
      .then((d) => setAlerts(d.alerts || []));
    // eslint-disable-next-line
  }, []);

  const count = Array.isArray(watchlist) ? watchlist.length : 0;

  const handleWLDelete = (ticker) => {
    dispatch(deleteWatchlistItem(ticker)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        alert("Ticker removed from your watchlist");
      } else {
        alert("Failed to remove ticker: " + res.payload);
      }
    });
  };

  const markRead = (id) => {
    fetch(`/api/watchlist/alerts/${id}/read/`, {
      method: "POST",
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    setAlerts((prev) =>
      prev.map((a) => (a.id === id ? { ...a, is_read: true } : a)),
    );
  };

  // 🔹 Sorting logic
  const sortedWatchlist = React.useMemo(() => {
    if (!Array.isArray(watchlist)) return [];
    let sortableItems = [...watchlist];
    if (sortConfig.key !== null) {
      sortableItems.sort((a, b) => {
        let valA = a[sortConfig.key];
        let valB = b[sortConfig.key];

        if (typeof valA === "string") {
          valA = valA.toLowerCase();
          valB = valB.toLowerCase();
        }

        if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
        if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sortableItems;
  }, [watchlist, sortConfig]);

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  return (
    <div className="container">
      <div className="row mt-4">
        <div style={{ fontSize: "20px" }}>My Watchlist</div>
        <p className="mt-2">{count} items</p>
      </div>

      {count === 0 ? (
        <div className="row mt-4">
          <div className="watchlist-empty">Your watchlist is empty</div>
        </div>
      ) : (
        <div className="row">
          <table className="watchlist-table mt-3">
            <thead>
              <tr>
                <th onClick={() => requestSort("ticker")}>
                  Ticker <FaSort style={{ fontSize: "15px", marginLeft: 6 }} />
                </th>
                <th onClick={() => requestSort("company")}>
                  Company <FaSort style={{ fontSize: "15px", marginLeft: 6 }} />
                </th>
                <th onClick={() => requestSort("latest_price")}>
                  Latest Price{" "}
                  <FaSort style={{ fontSize: "15px", marginLeft: 6 }} />
                </th>
                <th onClick={() => requestSort("pchange")}>
                  % Change{" "}
                  <FaSort style={{ fontSize: "15px", marginLeft: 6 }} />
                </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {sortedWatchlist.map((item, index) => (
                <tr key={index}>
                  <td
                    className="wlitem"
                    onClick={() => {
                      dispatch(fetchStockDetails(item.ticker));
                      navigate("/discover");
                    }}
                  >
                    {item.ticker}
                  </td>
                  <td>{item.company}</td>
                  <td>${item.latest_price.toFixed(2)}</td>
                  <td>
                    <span
                      className={
                        item.pchange > 0 ? "pp" : item.pchange < 0 ? "pn" : ""
                      }
                    >
                      {item.pchange.toFixed(2)}%
                    </span>
                  </td>
                  <td>
                    <span
                      className="delbutton"
                      onClick={() => handleWLDelete(item.ticker)}
                    >
                      <img
                        src={deleteicon}
                        alt="delete"
                        height={18}
                        width={18}
                      />
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Watchlist;
